import { ReactNode } from "react";
import { surfaceInfoText } from "./surfaceInfoText.css";

const SurfaceInfoText = ({ children }: { children: ReactNode }) => (
  <p className={surfaceInfoText}>{children}</p>
);

export default SurfaceInfoText;
